const downloadPdf = (response: any, fileName?: string) => {
  const filename =
    fileName ||
    response?.headers?.get('Content-Disposition')?.split('filename=')[1];
  const url = window.URL.createObjectURL(new Blob([response.data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', `${filename || 'unknownfile'}.pdf`);
  document.body.appendChild(link);
  link.click();
  link.remove();
};
export { downloadPdf };
